import { Fragment } from "react";
import { Checkbox } from "primereact/checkbox";

const ViewAssessmentMCQExamQuestion = ({ index, input }) => {
    const question = input && input.question;
    return (
        <Fragment>
            <div className="row m-0 pl-3 pr-3">
                <div className="col-12">
                    <hr></hr>
                    <label className="question ps-3 py-2" style={{ color: '#0F75BC' }}>{index + 1}. {question}</label>
                    <hr></hr>
                </div>
            </div>
            {
                input.options &&
                input.options.length > 0 &&
                input.options.map((m, i) => (
                    <div className="row m-0 pl-3 pr-3 py-2" key={i}>
                        <div className="col-12">
                            <div className={`d-flex align-items-center ps-3 m-2 
                            ${m.isAnswer && input.answer !== m.id ? 'text-correct-answer' : ''} 
                            ${m.isAnswer && input.answer === m.id ? 'text-success' : ''} 
                            ${m.isAnswer === false && input.answer === m.id ? 'text-danger' : ''}`}>
                                <Checkbox
                                    inputId={m.id}
                                    disabled={true}
                                    checked={input.answer === m.id}
                                />
                                <label htmlFor={m.id} className="m-auto ms-3">{m.option}</label>
                                <label htmlFor={m.id} className="ms-auto ms-3">
                                    {`${m.isAnswer && input.answer !== m.id ? 'Correct Answer' : ''}
                                    ${m.isAnswer && input.answer === m.id ? 'Right Answer' : ''}
                                    ${m.isAnswer === false && input.answer === m.id ? 'Your Answer' : ''}`}
                                </label>
                            </div>
                        </div>
                    </div>
                ))}
            <hr className="mx-2" />
        </Fragment>
    );
};

export default ViewAssessmentMCQExamQuestion;
